export const formatCurrency = (val) => new Intl.NumberFormat('en').format(val);
